import { gql } from "@apollo/client";

export const GET_DEDUCTION_VALIDITIES_LOOKUP = gql`
  query DeductionValiditiesLookup {
    masterDataDeductionValiditiesLookup {
      count
      items {
        id
        validityKey
        validityName
        orderNumber
      }
    }
  }
`;
